import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Typography, UiKits } from "../../../Constants/Constants";
import Headings from "./Headings/Headings";
import ColoredHeadings from "./ColoredHeadings/ColoredHeadings";
import FontWeight from "./FontWeight/FontWeight";
import Listing from "./Listing/ListingTypography";
import DisplayHeading from "./DisplayHeading/DisplayHeadings";
import InlineTextElements from "./InlineTextElements/InlineTextElements";
import TextColor from "./TextColor/TextColor";
import BlockQuotesCard from "./BlockQuotesCard/BlockQuotes";

const TypographyContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Typography} parent={UiKits} />
      <Container fluid>
        <Row>
          <Headings />
          <ColoredHeadings />
          <FontWeight />
          <Listing />
          <DisplayHeading />
          <InlineTextElements />
          <TextColor />
          <BlockQuotesCard />
        </Row>
      </Container>
    </>
  );
};

export default TypographyContainer;
